// src/services/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
//import { getAnalytics } from "firebase/analytics";

// Configuration VALETIER (base principale)
const valetierConfig = {
  apiKey: "AIzaSyBFlwZ-5P7EoIGXXP0eCyM5buTqnwQo7zc",
  authDomain: "valetier-48bb4.firebaseapp.com",
  projectId: "valetier-48bb4",
  storageBucket: "valetier-48bb4.firebasestorage.app",
  messagingSenderId: "458141418610",
  appId: "1:458141418610:web:3533cd01113d10aae1eeeb",
  measurementId: "G-75F8BR2D59"
};

// Configuration EXTRA (base secondaire pour consommations)
const extraConfig = {
  apiKey: "AIzaSyDqT65s5H662aYLwksoxN4UiY2wawUTgQQ",
  authDomain: "honesbar.firebaseapp.com",
  projectId: "honesbar",
  storageBucket: "honesbar.firebasestorage.app",
  messagingSenderId: "448381049746",
  appId: "1:448381049746:web:1619f8a0ab437982dbbf4b"
};

// Configuration SIRVOY ARCHIVES (base tertiaire pour historique)
const sirvoyConfig = {
  apiKey: "AIzaSyCQWPUnVI-Z4_K8gEdN2tjtkuqHtiCFwkc",
  authDomain: "valetier-exportsirvoy.firebaseapp.com",
  projectId: "valetier-exportsirvoy",
  storageBucket: "valetier-exportsirvoy.firebasestorage.app",
  messagingSenderId: "881528476230",
  appId: "1:881528476230:web:a8a3d5c5abc215a9e3f047",
  measurementId: "G-CWX4XBRCNH"
};

// Initialiser les trois apps Firebase
const valetierApp = initializeApp(valetierConfig, "valetier");
const extraApp = initializeApp(extraConfig, "extra");
const sirvoyApp = initializeApp(sirvoyConfig, "sirvoy");

// Export des services VALETIER (pour compatibilité avec l'existant)
export const auth = getAuth(valetierApp);
export const db = getFirestore(valetierApp);
export const storage = getStorage(valetierApp);
export const functions = getFunctions(valetierApp);
//export const analytics = getAnalytics(valetierApp);

// Export des instances Firestore séparées
export const valetierDb = getFirestore(valetierApp);
export const extraDb = getFirestore(extraApp);
export const sirvoyDb = getFirestore(sirvoyApp);

export default valetierApp;